import React, { Fragment, useCallback, useEffect, useState } from "react";
import { CheckboxButton, CheckboxLabel, CheckboxWrapper, QuestionListContainer, QuestionListTitle, QuestionListWrapper, Square } from "./style";
import { ReportQuestion } from "./components/ReportQuestion";
import { useReport } from "../../context/ReportContext";

export const QuestionList = () => {
  const { setSelectedQuestion, questionList, questionState, setQuestionState} = useReport();
  const [selectAllChecked, setSelectAllChecked] = useState(false);

  // Inicializa o array de questionState para garantir a paridade dos dados
  useEffect(() => {
    if (questionList.length > 0) {
      setQuestionState([
        ...questionState,
        {...buildReportConfig()},
        ...questionList.map((q) => ({
          id: q.id,
          enunciado: q.enunciado,
          selected: false,
          checked: false,
          index: q.index,
          graficos: q.graficos
        })),
      ]);
      setSelectedQuestion(buildReportConfig());
    }
  }, [questionList]);

  // Retorna o objeto de configuração com estrutura similiar a uma pergunta
  function buildReportConfig() {
    return {
      id: -1,
      enunciado: "Configurar dados do relatório",
      selected: true,
      checked: false,
    };
  }

  const onCheck = (questionId) => {
    updateQuestionStateProxy(questionId, "check");
  };

  const onSelect = useCallback(
    (questionId) => {
      updateQuestionStateProxy(questionId, "select");
      const currentQuestion = questionState.find(q => q.id === questionId);
      setSelectedQuestion(currentQuestion);
    },
    [questionState]
  );

  const updateQuestionStateProxy = useCallback((questionId, action) => {
    setQuestionState((prevState) => {
      return prevState.map((item) => {
        if (item.id === questionId) {
          if (action === "check") {
            return { ...item, checked: !item.checked };
          } else if (action === "select") {
            return { ...item, selected: true };
          }
        }
        // Desmarca os outros itens ao selecionar
        return action === "select" ? { ...item, selected: false } : item;
      });
    });
  }, []);

  /**
   * Alterna o estado de seleção de todas as perguntas na lista.
   * Quando o checkbox é marcado, define o estado `checked` de todas
   * as perguntas para `true`. Quando desmarcado, define para `false`.
   * 
   * Utiliza o estado `selectAllChecked` para determinar o estado atual do checkbox.
   * Atualiza o estado `questionState` para refletir a seleção de todas as perguntas.
   * 
 */
  const handleSelectAll = () => {
    setSelectAllChecked(!selectAllChecked);
    setQuestionState((prevState) => {
      return prevState.map((item) => ({
        ...item,
        checked: !selectAllChecked
      }));
    });
  };

  return (
    <QuestionListContainer>
      <QuestionListWrapper>
        <QuestionListTitle>Informações da avaliação</QuestionListTitle>
        {questionState?.map((question) => {
          return (
            <Fragment key={question.id}>
              <ReportQuestion
                questionTitle={question.enunciado}
                questionId={question.id}
                checked={question.checked}
                selected={question.selected}
                onCheck={onCheck}
                onSelect={onSelect}
                hasCheckbox={question.id !== -1}
              />
              {question.id === -1 && 
              <>
                <QuestionListTitle>Perguntas do questionário</QuestionListTitle>
                <CheckboxWrapper>
                  <CheckboxButton onClick={handleSelectAll}>
                    <Square isChecked={selectAllChecked} />
                  </CheckboxButton>
                  <CheckboxLabel>Selecionar tudo</CheckboxLabel>
                </CheckboxWrapper>
              </>
              }
            </Fragment>
          );
        })}
      </QuestionListWrapper>
    </QuestionListContainer>
  );
};
